import { useContext, useEffect, useState } from 'react';

import './EditPricePopup.css';
import AdaptivePopup from '../../../../../../AdaptivePopup/AdaptivePopup';
import PlatformInput from '../../../../../PlatformInput/PlatformInput';
import Button from '../../../../../../Button/Button';
import { ERROR_PRICE_DATA_MIN_VALUE, ERROR_REQUIRED_FIELD } from '../../../../../../../assets/utils/constants';








function EditPricePopup({ isOpen, handleClose, handleEditSave, productToEdit, setProductToEdit }) {
    const [formValidity, setFormValidity] = useState({
        price: {},
    })

    useEffect(() => {
        if (!productToEdit) return
        setFormValidity({
            price: {
                validState: productToEdit && Number(productToEdit.price) > 0 ? true : false
            },
        })

    }, [productToEdit])


    function handleChange(e) {
        const value = e.target.value
        const name = e.target.name
        switch (name) {
            case "price": {
                let inputValue = value.replace(/\D/g, "");
                setProductToEdit((prevValue) => ({
                    ...prevValue,
                    [name]: !inputValue ? "" : Number(inputValue).toString(),
                }));
                setFormValidity((prevValue) => ({
                    ...prevValue,
                    [name]: inputValue
                        ? Number(inputValue) > 0
                            ? {
                                errorMessage: "",
                                validState: true,
                            }
                            : {
                                errorMessage: ERROR_PRICE_DATA_MIN_VALUE,
                                validState: false,
                            }
                        : {
                            errorMessage: ERROR_REQUIRED_FIELD,
                            validState: false,
                        },
                }));
                break;
            }

            
            default: {
                setProductToEdit(prevValue => ({
                    ...prevValue,
                    [name]: value,
                }))
                break;
            }
        }
    }
    function onClosePopup() {
        handleClose()
        setTimeout(() => {
            setProductToEdit(null)
        }, 300);
    }

    function handleSave() {
        handleEditSave(productToEdit)
        onClosePopup()
    }
    return (
        <AdaptivePopup
            isOpen={isOpen}
            handleClose={onClosePopup}
            popupName={'editProduct'}
        >
            {productToEdit ?
                <div className='edit-price-popup'>
                    <p className='edit-price-popup__title'>Редактировать цену</p>
                    <PlatformInput
                        value={productToEdit.price}
                        handleChange={handleChange}
                        label={'Цена'}
                        type={'text'}
                        inputMode='numeric'
                        name={'price'}
                        show_eror_color_only

                    />
                   
                    <Button
                        text={'Cохранить'}
                        isInvalid={!(formValidity.price.validState && productToEdit.price)}
                        isContrastColor
                        className={'edit-price-popup__btn '}
                        onClick={() => {
                            handleSave()
                        }}
                    />
                </div>
                :
                null
            }
        </AdaptivePopup>
    );
}

export default EditPricePopup